var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternPricing5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 811.42 964.86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.72 -1156.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m797.42 2061.36a29.19 29.19 0 1 1 0 58.38h-29.19v-29.19a29.19 29.19 0 0 1 29.19-29.19z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m826.36 2059.15-2.12 13.85-13.82-2.12a21 21 0 0 1 -17.55-23.91l2.12-13.82 13.82 2.12a21 21 0 0 1 17.55 23.88z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.45 1156.27a74.7 74.7 0 1 0 0 149.39h74.69v-74.66a74.69 74.69 0 0 0 -74.69-74.73z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785.47 1272.82a44.67 44.67 0 0 0 0 89.33h44.67v-44.67a44.66 44.66 0 0 0 -44.67-44.66z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.45 1184.61a45.61 45.61 0 1 0 45.6 45.6 45.61 45.61 0 0 0 -45.6-45.6z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e72e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m682.75 1215a26.7 26.7 0 1 0 26.7 26.7 26.69 26.69 0 0 0 -26.7-26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.65 1533.23a9.95 9.95 0 1 0 9.94 9.94 9.94 9.94 0 0 0 -9.94-9.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m740.81 1782.57a9.94 9.94 0 1 0 9.94 9.94 9.95 9.95 0 0 0 -9.94-9.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.42 2049.45v71.68h-71.69a72.39 72.39 0 0 1 -72.4-72.4v-71.73h71.67a72.41 72.41 0 0 1 72.42 72.45z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m134.28 2049.09a42.36 42.36 0 1 1 -84.71 0v-42.36h42.35a42.36 42.36 0 0 1 42.36 42.36z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.76 1941.32v28.82h-28.82a43.23 43.23 0 0 1 -43.22-43.23v-28.82h28.82a43.22 43.22 0 0 1 43.22 43.23z",
    fill: "#5e72e4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternPricing5);
export default __webpack_public_path__ + "static/media/pattern_pricing5.ad8cee008609cb07dd7a9b515be32919.svg";
export { ForwardRef as ReactComponent };